import { render, staticRenderFns } from "./NetaEventDetailsView.vue?vue&type=template&id=92f5bd10&scoped=true&"
import script from "./NetaEventDetailsView.vue?vue&type=script&lang=js&"
export * from "./NetaEventDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./NetaEventDetailsView.vue?vue&type=style&index=0&id=92f5bd10&lang=scss&scoped=true&"
import style1 from "./NetaEventDetailsView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f5bd10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92f5bd10')) {
      api.createRecord('92f5bd10', component.options)
    } else {
      api.reload('92f5bd10', component.options)
    }
    module.hot.accept("./NetaEventDetailsView.vue?vue&type=template&id=92f5bd10&scoped=true&", function () {
      api.rerender('92f5bd10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app-views/NetaEventDetailsView.vue"
export default component.exports